var map = {
	"./007-microphone-1.png": 631,
	"./010-home.png": 632,
	"./013-document-1.png": 633,
	"./014-document.png": 634,
	"./015-color-palette.png": 635,
	"./017-video-camera.png": 636,
	"./024-like.svg": 637,
	"./1.svg": 638,
	"./155-credit-card.svg": 639,
	"./2.svg": 640,
	"./3.svg": 641,
	"./4.svg": 642,
	"./New Customer.svg": 643,
	"./NotOpen.svg": 644,
	"./Opened.svg": 645,
	"./Profit.svg": 646,
	"./SalesRevenue.svg": 647,
	"./Sent.svg": 648,
	"./Slack.svg": 649,
	"./address.svg": 650,
	"./adobe.svg": 651,
	"./arrow-left.svg": 453,
	"./arrow-right.svg": 454,
	"./book.svg": 652,
	"./camera.svg": 653,
	"./chat.svg": 654,
	"./clipboard.svg": 655,
	"./cloud.svg": 656,
	"./columns.svg": 657,
	"./documentation.svg": 658,
	"./file.svg": 659,
	"./flat.svg": 660,
	"./headphone.svg": 661,
	"./iconfinder_trello_2317760.svg": 662,
	"./idea.svg": 663,
	"./image.png": 664,
	"./image.svg": 665,
	"./label.png": 666,
	"./layers.svg": 667,
	"./left.svg": 668,
	"./logo2.svg": 669,
	"./logo3.svg": 670,
	"./logo4.svg": 671,
	"./logo5.svg": 672,
	"./logo6.svg": 673,
	"./logoIn.svg": 674,
	"./paint.svg": 675,
	"./protection.svg": 676,
	"./quote.png": 677,
	"./repeat.svg": 678,
	"./right.svg": 679,
	"./strategy.svg": 680,
	"./theme.svg": 681,
	"./user.svg": 682,
	"./water-fall.svg": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 630;